export default "__VITE_ASSET__DzZnFwEg__"